import React from 'react';
export var ReactReduxContext = React.createContext(null);
export default ReactReduxContext;


//////////////////
// WEBPACK FOOTER
// ../node_modules/react-redux/es/components/Context.js
// module id = 105
// module chunks = 0